<template>
    <v-container grid-list-xl>

        <cook :loading="loading" v-if="cooksByIngredients.length > 0" :cooks="cooksByIngredients" v-on:deleteCook="deleteCook" />

        <v-layout column align-center v-else>
            <v-flex xs12 sm6>
                <v-layout row>
                    <v-flex ma-5>
                        <h1 class="text-center cook_name">لا يوجد طبخة بهذه المقادير</h1>
                    </v-flex>
                </v-layout>

                <v-layout justify-center align-center row>
                    <v-flex>
                        <v-btn justify-end color="secondary" class="black-text" to="/cook/add">إضافة طبخة</v-btn>
                    </v-flex>

                     <v-flex>
                        <v-btn color="secondary" class="black-text" to="/">جرب مرة أخرى</v-btn>            
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>

        <v-layout row>
           
            <v-dialog v-model="loading" v-if="!loading" persistent fullscreen>
                <v-container fill-height>
                    <v-layout row justify-center align-center>
                        <v-progress-circular indeterminate :size="70" :width="7" color="secondary"></v-progress-circular>
                    </v-layout>
                </v-container>
            </v-dialog>
        </v-layout>

    </v-container>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    import Cook from '../Shared/Cook.vue'

    const pageSize = 9

    export default {
        name: 'ByIngredients',
        components: {
            'cook': Cook
        },
        computed: {
            ...mapGetters(['loading', 'user', 'error', 'cooksByIngredients'])
        },
        watch: {
            user(value) {
                // If user value changes, redirect to home page
                if(value) {
                    this.$router.push('/')
                }
            }
        },
        methods: {
            deleteCook(cookId) {
                this.$store.dispatch('deleteCook', cookId)               
            },
            goToCook(cookId) {
                this.$router.push(`/cooks/${cookId}`)
            }
        }
    }
</script>

<style scoped>
.cook-1 {
    font-size: 2.125rem !important;
    font-weight: 400;
    line-height: 2.5rem;
    letter-spacing: 0.0073529412em !important;
    font-family: 'Almarai', sans-serif !important; /* this was it */
}
</style>